import classNames from "classnames";

const MenuWrapper = (props: { className?: string } & React.PropsWithChildren) => {
    return <div className={classNames("w-64 p-3 border-[1px] border-menu-border bg-menu-background text-primary relative shadow-xl z-20 flex flex-col rounded-lg", props.className)}>
        {props.children}
    </div>;
}

export default MenuWrapper;